import sendGtmEvent from "./sendGtmEvent";
export default function registrationFinishDetect(user) {
  const lc = localStorage;
  const lc_key = "sf_reg_finish";
  if (!user.isNew) {
    return false;
  }
  var user_reg_csaid_list = lc.getItem(lc_key);

  if (!user_reg_csaid_list) {
    user_reg_csaid_list = [];
  } else {
    try {
      user_reg_csaid_list = JSON.parse(value);
    } catch (e) {
      console.error("CANT PARSE localStorage sf_reg_finish");
      return false;
    }
  }
  //такого юзера уже посчитали
  if (user_reg_csaid_list.indexOf(user.csaid) > -1) {
    return false;
  } else {
    user_reg_csaid_list.push(user.csaid);
    var ep = user.socialEp ? user.socialEp : "mail";
    sendGtmEvent("ch.registration.finish", {
      userID: user.csaid,
      auth_type: ep,
    });
    ls.setItem(lc_key, JSON.stringify(user_reg_csaid_list));
  }
}
